import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { ClientDataGood } from '../../../../../../../Adapter';
import { FormName } from '../../../../../../context';
import { SelectOption } from '../../../../../../../../../../types/select';

interface ShipmentTypeTags extends FormName {
  goodsItem: ClientDataGood;
  index: number;
}

function ShipmentTypeTags({ goodsItem }: ShipmentTypeTags) {
  const [shipmentTypes, setShipmentTypes] = useState<string[]>([]);

  useEffect(() => {
    const activeTags: string[] = [];

    // Show "Dry ice" if netWeightOfDryIce > 0
    if (goodsItem?.specialTemperatureMode && goodsItem?.netWeightOfDryIce > 0) {
      activeTags.push('Dry Ice');
    }

    if (goodsItem?.dangerousGood_view?.startsWith('3373')) {
      activeTags.push('Biological Substance UN3373');
    }

    // Show "GMO UN3245" if dangerousGood_view starts with "3245"
    if (goodsItem?.dangerousGood_view?.startsWith('3245')) {
      activeTags.push('GMO UN3245');
    }

    // Check packaging type for EQ or Limited Quantities
    const packagingLabel = (goodsItem?.packaging as SelectOption)?.label;
    const stringPackagingLabel = typeof packagingLabel === 'string' ? packagingLabel?.toLowerCase() : '';

    if (stringPackagingLabel === 'Box (Excepted Quantities)'.toLowerCase()) {
      activeTags.push('EQ (Excepted Quantities)');
    } else if (stringPackagingLabel === 'Box (Limited Quantities)'.toLowerCase()) {
      activeTags.push('Limited Quantities ADR');
    }
    // if (packagingLabel === 'Box (Excepted Quantities)') {
    //   activeTags.push('EQ (Excepted Quantities)');
    // } else if (packagingLabel === 'Box (Limited quantities)') {
    //   activeTags.push('Limited Quantities ADR');
    // }

    // Show "LiBa" if hasLithiumBattery is true
    if (goodsItem?.hasLithiumBattery) {
      activeTags.push('LiBa');
    }

    // Show "Full DG" if fullDg is true
    if (goodsItem?.isFullDG) {
      activeTags.push('Full DG');
    }

    // Show "Not Restricted" if isNotRestricted is true
    if (goodsItem?.isNotRestricted) {
      activeTags.push('Not Restricted');
    }

    setShipmentTypes(activeTags);
  }, [goodsItem]);

  return (
    <div className={clsx(styles.formGridHorizontal)}>
      <span className={styles.title}>
        <span>Shipment type</span>
        <span className={styles.separator}>:</span>
      </span>
      <div className={styles.flexRow}>
        {(shipmentTypes.length > 0 ? shipmentTypes : ['None']).map((item) => (
          <span key={item} className={styles.value}>{item}</span>
        ))}
      </div>
    </div>
  );
}

export default ShipmentTypeTags;
